import { render, staticRenderFns } from "./cpwd.vue?vue&type=template&id=5badc425&scoped=true"
import script from "./cpwd.vue?vue&type=script&lang=js"
export * from "./cpwd.vue?vue&type=script&lang=js"
import style0 from "./cpwd.vue?vue&type=style&index=0&id=5badc425&prod&lang=scss"
import style1 from "./cpwd.vue?vue&type=style&index=1&id=5badc425&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5badc425",
  null
  
)

export default component.exports